<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="rank-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 搜索项 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>
          </div>

          <!-- 搜索/重置/列筛选 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getUserPrizeDataList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="240"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                >{{ item.label }}</el-checkbox>
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="序号"
            width="80"
            align="center"
            v-if="checkedColumns.includes('index')"
          >
            <template slot-scope="scope">
              {{ (searchParams.page - 1) * searchParams.page_size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            min-width="160"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="用户昵称"
            prop="nickname"
            min-width="180"
            v-if="checkedColumns.includes('nickname')"
          />
          <!-- 金币 -->
          <el-table-column
            label="金币"
            prop="balance"
            width="130"
            align="center"
            v-if="checkedColumns.includes('balance')"
          >
            <template slot-scope="scope">
              <span style="color: #409EFF; font-weight: bold">{{ scope.row.balance || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 钻石 -->
          <el-table-column
            label="钻石"
            prop="point"
            width="130"
            align="center"
            v-if="checkedColumns.includes('point')"
          >
            <template slot-scope="scope">
              <span style="color: #67C23A; font-weight: bold">{{ scope.row.point || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 无限币 blind_point -->
          <el-table-column
            label="无限币"
            prop="blind_point"
            width="130"
            align="center"
            v-if="checkedColumns.includes('blind_point')"
          >
            <template slot-scope="scope">
              <span style="color: #9254de; font-weight: bold">{{ scope.row.blind_point || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 擂台币 challenge_point -->
          <el-table-column
            label="擂台币"
            prop="challenge_point"
            width="130"
            align="center"
            v-if="checkedColumns.includes('challenge_point')"
          >
            <template slot-scope="scope">
              <span style="color: #f56c6c; font-weight: bold">{{ scope.row.challenge_point || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 闯关币 fight_point -->
          <el-table-column
            label="闯关币"
            prop="fight_point"
            width="130"
            align="center"
            v-if="checkedColumns.includes('fight_point')"
          >
            <template slot-scope="scope">
              <span style="color: #ff7d00; font-weight: bold">{{ scope.row.fight_point || 0 }}</span>
            </template>
          </el-table-column>
          <!-- PK币 pk_point -->
          <el-table-column
            label="PK币"
            prop="pk_point"
            width="130"
            align="center"
            v-if="checkedColumns.includes('pk_point')"
          >
            <template slot-scope="scope">
              <span style="color: #17c3b2; font-weight: bold">{{ scope.row.pk_point || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 流水 cost_price -->
          <el-table-column
            label="流水"
            prop="cost_price"
            width="140"
            align="center"
            v-if="checkedColumns.includes('cost_price')"
          >
            <template slot-scope="scope">
              <span style="font-weight: bold; color: #e63946">¥{{ scope.row.cost_price || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 赏袋总兑换价值 -->
          <el-table-column
            label="赏袋总兑换价值"
            width="160"
            align="center"
            v-if="checkedColumns.includes('recovery_price')"
            fixed="right"
          >
            <template slot-scope="scope">
              <span style="font-weight: bold; color: #E6A23C">¥{{ scope.row.recovery_price }}</span>
            </template>
          </el-table-column>
         
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-rank-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getUserPrizeDataList"
            style="flex: 1"
          >搜索</el-button>
          <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="(item, index) in tableData"
            :key="item.user_id + '_' + index"
          >
            <div class="card-header">
              <div style="display: flex; align-items: center; gap: 10px">
                <div class="rank-tag">
                  <span class="tag-normal">
                    {{ (searchParams.page - 1) * searchParams.page_size + index + 1 }}
                  </span>
                </div>
                <el-avatar :src="item.avatar" size="50"></el-avatar>
                <div class="info">
                  <div class="nickname">{{ item.nickname || "未知用户" }}</div>
                  <div class="uid">用户ID: {{ item.user_id }}</div>
                  <div class="uid">用户编号：{{ item.user_no }}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div style="font-size: 14px; margin-bottom:4px;">
                赏袋总兑换价值：
                <span style="font-weight: bold; color: #E6A23C">¥{{ item.recovery_price }}</span>
              </div>
              <div style="font-size: 14px; margin-bottom:4px;">
                金币：
                <span style="font-weight: bold; color: #409EFF">{{ item.balance || 0 }}</span>
              </div>
              <div style="font-size: 14px; margin-bottom:4px;">
                钻石：
                <span style="font-weight: bold; color: #67C23A">{{ item.point || 0 }}</span>
              </div>
              <!-- 无限币 -->
              <div style="font-size: 14px; margin-bottom:4px;">
                无限币：
                <span style="font-weight: bold; color: #9254de">{{ item.blind_point || 0 }}</span>
              </div>
              <!-- 擂台币 -->
              <div style="font-size: 14px; margin-bottom:4px;">
                擂台币：
                <span style="font-weight: bold; color: #f56c6c">{{ item.challenge_point || 0 }}</span>
              </div>
              <!-- 闯关币 -->
              <div style="font-size: 14px; margin-bottom:4px;">
                闯关币：
                <span style="font-weight: bold; color: #ff7d00">{{ item.fight_point || 0 }}</span>
              </div>
              <!-- PK币 -->
              <div style="font-size: 14px; margin-bottom:4px;">
                PK币：
                <span style="font-weight: bold; color: #17c3b2">{{ item.pk_point || 0 }}</span>
              </div>
              <!-- 流水 -->
              <div style="font-size: 14px;">
                流水：
                <span style="font-weight: bold; color: #e63946">¥{{ item.cost_price || 0 }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "UserPrizeData",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },

      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },

      // 列筛选配置【新增5个字段】
      columnOptions: [
        { label: "序号", prop: "index" },
        { label: "头像", prop: "avatar" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户编号", prop: "user_no" },
        { label: "用户昵称", prop: "nickname" },
        { label: "金币balance", prop: "balance" },
        { label: "积分point", prop: "point" },
        { label: "无限币blind_point", prop: "blind_point" },
        { label: "擂台币challenge_point", prop: "challenge_point" },
        { label: "闯关币fight_point", prop: "fight_point" },
        { label: "PK币pk_point", prop: "pk_point" },
        { label: "流水cost_price", prop: "cost_price" },
        { label: "赏袋总兑换价值", prop: "recovery_price" },
      ],
      // 默认勾选全部字段
      checkedColumns: [
        "index",
        "avatar",
        "user_id",
        "user_no",
        "nickname",
        "balance",
        "point",
        "blind_point",
        "challenge_point",
        "fight_point",
        "pk_point",
        "cost_price",
        "recovery_price",
      ],

      searchCollapsed: true,
    };
  },
  created() {
    this.getUserPrizeDataList();
  },
  methods: {
    // 获取用户赏袋数据列表
    async getUserPrizeDataList() {
      this.loading = true;
      try {
        const res = await api.users.getUserPrizeData({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索条件
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getUserPrizeDataList();
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getUserPrizeDataList();
    },
    // 页码切换
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getUserPrizeDataList();
    },

    // 列筛选全选/清空
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 折叠搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
/* PC样式 */
.rank-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端样式 */
.mobile-rank-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.rank-tag {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
}
.tag-normal {
  width: 32px;
  height: 32px;
  background: #eee;
  color: #666;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info .nickname {
  font-size: 16px;
  font-weight: 500;
}
.info .uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
}
</style>

<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/loss/userPrizeData.vue